import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DocumentsManagerService } from 'core/services/documents-manager.service';

@Component({
  selector: 'lms-image-uploader-positioner',
  templateUrl: './image-uploader-positioner.component.html',
  styleUrls: ['./image-uploader-positioner.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageUploaderPositionerComponent),
      multi: true
    }
  ]
})
export class ImageUploaderPositionerComponent implements OnInit, ControlValueAccessor {
  @Input() getPosition: any;
  public bannerImg: string;
  public position: number = 0;
  moving: boolean = false;
  backgroundGrid: boolean = false;
  clickedPoint: number = 0;
  bannerMobilePosition: number = 0;

  public propagateChange = (_: any) => {};
  public propagateTouched = (_: any) => {};

  constructor(public documentsManagerService: DocumentsManagerService) {}

  writeValue(value: any) {
    this.position = value;
  }
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn) {
    this.propagateTouched = fn;
  }

  ngOnInit() {
    this.documentsManagerService.bannerImg.subscribe((bannerImg) => {
      this.bannerImg = bannerImg;
    });
    this.position = this.getPosition ? this.getPosition : 0;
  }

  handleStageMouseDown(e: any) {
    this.moving = true;
    this.clickedPoint = e.offsetX;
  }

  moveBackgroundGrid() {
    this.backgroundGrid = !this.backgroundGrid;
  }

  disableMove() {
    if (this.backgroundGrid) {
      this.clickedPoint = 0;

      this.moving = false;
      this.propagateChange(this.bannerMobilePosition);
    }
  }

  handleStageMouseMove(e: any) {
    if (this.moving && this.backgroundGrid) {
      const moved = (e.offsetX - this.clickedPoint) / 50;
      this.bannerMobilePosition = Math.trunc(moved + this.bannerMobilePosition);
      this.position = Math.trunc(moved + this.bannerMobilePosition);
    }
  }
}
